// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes/Shop.less
 ** module id = 467
 ** module chunks = 0
 **/